import { Platform, Dimensions } from 'react-native'

export const isMobile = () => Platform.OS === 'ios' || Platform.OS === 'android'

export const isTablet = () => {
  if (!isMobile()) return false
  const { width, height } = Dimensions.get('screen')
  return Math.max(height / width, width / height) <= 1.6
}
